<script async setup lang="ts">
import { EventEntity } from '@/entities/interfaces/events';
import { useViewStore } from '@/stores/view.store';
import { useEventStore } from '@/stores/events.store';
import { computed, onMounted, ref, watch } from 'vue';
import { getPhotos } from '@/entities/api/photos';

import BreadcrumbComponent from '@/components/custom/ui/BreadcrumbComponent.vue';
import PhotoPreview from '@/components/custom/preview/PhotoPreview.vue';

interface GalleryItem {
  id: string;
  eventId: string;
  name: string;
  date: string;
  imageId: string;
  imagesNumber: number;
}

const viewStore = useViewStore();
const view = viewStore.getViewType;

const eventStore = useEventStore();
const prevEvents = computed<EventEntity[]>(
  () => eventStore.getEventsTimeline.value?.prevEvents
);

const galleryItems = ref<GalleryItem[]>();

const setGallery = () => {
  if (!prevEvents.value) return;
  Promise.all(
    prevEvents.value?.map((item) => {
      return getPhotos(item.id).then((images) => {
        if (!images.length) return;

        const mainImage =
          images.find((i) => i.id === item.mainGalleryImage) ?? images[0];

        return {
          id: mainImage.id,
          eventId: item.id,
          name: item.name,
          date: item.plannedDateTime,
          imageId: mainImage.imageId,
          imagesNumber: images.length
        };
      });
    })
  ).then(
    (result) => (galleryItems.value = result.filter((i) => i != undefined))
  );
};

watch(prevEvents, () => {
  setGallery();
});

onMounted(() => {
  setGallery();
});
</script>

<template>
  <section class="photos" v-if="prevEvents?.length > 0">
    <BreadcrumbComponent :paths="[{ name: 'Главная страница', link: '/' }]" />
    <h2>Фотогалерея</h2>
    <div class="photos-list">
      <PhotoPreview
        :styles="
          view == 'large'
            ? 'max-width: 440px;  margin: 0;'
            : view == 'desktop'
              ? 'max-width: calc(50% - 20px); margin: 0;'
              : ''
        "
        v-for="photo in galleryItems"
        :key="photo.id"
        :photo="photo"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.photos {
  h2 {
    font-size: var(--font-size-lm);
  }

  &-filters {
    gap: 12px;
    display: flex;
    flex-wrap: wrap;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media screen and (max-width: 1024px) {
      flex-wrap: nowrap;
      overflow-x: auto;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-list {
    gap: 40px;
    display: flex;
    flex-wrap: wrap;
    padding: 60px 0;

    .event-item {
      margin: 0;
      max-width: 440px;
    }
  }
}
</style>
